export const getStyled = (theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.custom.colors.defaultBackground,
  },

  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'auto',
    ...theme.custom.scrollbarStyles,
    backgroundColor: theme.custom.colors.defaultBackground,

    borderColor: theme.palette.mode === 'light' ? '#192734' : '#8C939A',

    color: ` ${theme.custom.colors.text} !important`,

    '& .MuiTableCell-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTypography-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiIconButton-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiAvatar-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },

  tab: {
    color: `${theme.custom.colors.text} !important`,
    backgroundColor: theme.custom.colors.defaultBackground,

    '& .MuiTab-root': {
      color: '#999999',
    },
    '& .Mui-selected': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: `${theme.custom.colors.text} !important`,
    },
  },

  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: theme.custom.colors.defaultBackground,
    borderColor: '#FFF',
  },

  container: {
    width: '100%',
    maxHeight: '100%',
  },

  control: {
    padding: theme.spacing(1),
  },

  textfield: {
    width: '100%',
  },
});
